import type { DownloadsMap } from '#api/downloads.queries.ts';
import { SelectItem } from '#components/patterns/forms/select/select-item/SelectItem.tsx';
import { Select } from '#components/patterns/forms/select/select/Select.tsx';
import type { ClientInfo, OSGroup } from '#dn-types/downloads.ts';
import type { ArchPickerOptions } from '../ArchitecturePicker.tsx';

type Props = {
  downloads: DownloadsMap;
  /** Linux picks its architecture inside the binary-download step; Mobile links both app stores. */
  group: Exclude<OSGroup, 'Linux' | 'Mobile'>;
  value: Exclude<ArchPickerOptions, 'macos-universal-desktop'> | '';
  onChange: (newVal: Exclude<ArchPickerOptions, 'macos-universal-desktop'> | '') => void;
  className?: string;
};

export function ArchitectureSelect({ downloads, group, onChange, value, className }: Props) {
  return (
    <>
      <h2 className="h3">2. Select version</h2>
      <Select
        label="Version"
        className={className}
        visuallyHideLabel={true}
        value={value}
        onChange={onChange}
        renderValue={(val) =>
          val === '' ? 'Please select…' : (downloads[group].find(({ key }) => key === val)?.label ?? 'Please select…')
        }
      >
        {downloads[group]
          .filter((arch) => {
            const a = arch as ClientInfo | undefined;
            // Don't show the macOS Desktop artifact for macOS Server instructions
            // And don't show the Windows Server artifacts for Windows Desktop instructions
            return (
              !['macos-universal-desktop', 'windows-amd64-server', 'windows-arm64-server'].includes(a?.key ?? '') &&
              (a?.url?.length ?? 0) > 0
            );
          })
          .map((arch) => (
            <SelectItem key={arch.key} value={arch.key}>
              {arch.label}
            </SelectItem>
          ))}
      </Select>
    </>
  );
}
